import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { LineDrawState } from '../../state/line.draw.state';
import { CSS, Style } from '../measurement.popup/measurement.popup.style';
import { IkeUnit } from '@ikegps/core-measurement';
import { Services } from '../../services';

addStyles(Style);

export interface LineDrawPopupConfig {
	onComplete: () => void;
	onCancel: () => void;
	lineDrawState: LineDrawState;
}

export const LineDrawPopup = {
	view(cfg: LineDrawPopupConfig): MithrilVNode {
		const state = cfg.lineDrawState;
		const canComplete = state.points.length >= 2;

		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.header }, [
				m('div', { className: CSS.title }, Translate(T.TOPO_TOOL_DRAW_LINE)),
				m('div', { className: CSS.headerActions }, [
					ImageButton.view(MaterialIcon.CHECK, {
						onclick: cfg.onComplete,
						title: T.LINE_DRAW_COMPLETE,
						disabled: !canComplete,
					}),
					ImageButton.view(MaterialIcon.CLOSE, {
						onclick: cfg.onCancel,
						title: T.LINE_DRAW_CANCEL,
					}),
				]),
			]),
			m('div', { className: CSS.content }, [
				state.points.length > 0
					? m('div', { className: CSS.measurementRow }, [
							m(
								'div',
								{ className: CSS.measurementLabel },
								Translate(T.FIELD_LINE_POINTS, { count: state.pointCount })
							),
							m(
								'div',
								{ className: CSS.measurementValue },
								IkeUnit.display(state.totalDistanceMeters, Services.UserSettings.units)
							),
						])
					: m('div', { className: CSS.emptyState }, Translate(T.LINE_DRAW_HINT)),
			]),
		]);
	},
};
